import MediaNotAvailable from '@components/media_not_available';
import { CATEGORY_SINGULAR_ABBREVIATED_TERMS } from '@constants/categories';
import { useAppSelector } from '@redux/hooks';
import { tkHost } from '@settings';
import {
	CtaButton,
	FullscreenModal,
	TextBody,
	TextHero,
} from '@tkww/orion-web-ds';
import React from 'react';
import Styles from './styles.scss';

interface BookVendorSuccessModalProps {
	isOpen: boolean;
	onClose: () => void;
}

export const BookVendorSuccessModal: React.FC<BookVendorSuccessModalProps> = ({
	isOpen,
	onClose,
}) => {
	const vendor = useAppSelector((state) => state.vendor.vendor);
	const handleFindMoreVendors = () => {
		window.location.href = `${tkHost}/marketplace`;
	};

	const vendorImage =
		vendor?.mediaSummary?.media?.[0]?.url || vendor?.storefrontCard?.url;

	const formatLocation = () => {
		return `${vendor?.address?.city}, ${vendor?.address?.state}` || '';
	};

	const vendorCategoryName = vendor
		? vendor.categorySingularTerm ||
			CATEGORY_SINGULAR_ABBREVIATED_TERMS[vendor.categoryCode] ||
			vendor.categoryPluralTerm
		: 'vendor';

	return (
		<FullscreenModal isOpen={isOpen} onClose={onClose} showLogo={false}>
			<div className={`${Styles.container} book-vendor-success-container`}>
				<div className={Styles.contentWrapper}>
					<TextHero size="md" className={Styles.title}>
						You've found a perfect fit for your wedding!
					</TextHero>
					<div className={Styles.vendorContentWrapper}>
						{vendorImage ? (
							<div className={Styles.imageWrapper}>
								<img
									src={vendorImage}
									alt={vendor?.name}
									className={Styles.vendorImage}
								/>
							</div>
						) : (
							<div className={Styles.imageNotAvailableWrapper}>
								<MediaNotAvailable />
							</div>
						)}
						<div className={Styles.vendorInfoWrapper}>
							<TextBody size="md" bold className={Styles.vendorName}>
								{vendor?.name}
							</TextBody>
							<TextBody size="sm" className={Styles.vendorInfo}>
								<span className={Styles.vendorLocation}>
									{formatLocation()}
								</span>{' '}
								·{' '}
								<span className={Styles.vendorCategory}>
									{vendorCategoryName}
								</span>
							</TextBody>
						</div>
					</div>
				</div>
				<div className={Styles.actionsWrapper}>
					<CtaButton
						as="button"
						treatAs="button"
						styleType="primary"
						size="lg"
						onClick={handleFindMoreVendors}
						className={Styles.ctaButton}
					>
						Find more vendors
					</CtaButton>
				</div>
			</div>
		</FullscreenModal>
	);
};
